import { render, staticRenderFns } from "./HelloSign.vue?vue&type=template&id=009226af&scoped=true&"
import script from "./HelloSign.vue?vue&type=script&lang=js&"
export * from "./HelloSign.vue?vue&type=script&lang=js&"
import style0 from "./HelloSign.vue?vue&type=style&index=0&id=009226af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009226af",
  null
  
)

export default component.exports